//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
    name: 'foot-bar',
    props: {
        tabs: Array, //菜单列表 [{url, icon, title}]
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                var index = this.tabs.findIndex(tab => {
                    var route = this.$router.options.routes.find(route => route.path === tab.url)
                    if (route && route.path === path) return true
                    return route && route.children && this.getChildrenPath(route.children, path)
                })
                if (index > -1) this.setBarIndex(index)
            }
        }
    },
    methods: {
        goTab() {
            const tab = this.tabs[this.barIndex]
            if (tab) this.$router.push(tab.url)
        },
        setBarIndex(index) {
            this.$store.dispatch('setBarIndex', index)
        },
        getChildrenPath(routes, path) {
            return routes.find(route => {
                return route.children ? this.getChildrenPath(route.children, path) : route.path === path
            });
        },
        getIconCls(icon, isActive) {
            if (!icon) icon = 'van-icon-description'
            if (icon.indexOf('van-') === 0) { //支持vant图标
                return 'van-icon ' + icon
            }
            //嘉扬提供的icon
            return 'kyi-' + icon + (isActive ? '_active' : '')
        },
    },
    computed: {
        ...mapGetters(['barIndex']),
        // textStyle() {
        //     var bg = this.$x.userInfo.footerBg
        //     if (bg) {
        //         var r = Number('0x' + bg.slice(0, 2))
        //         var g = Number('0x' + bg.slice(2, 4))
        //         var b = Number('0x' + bg.slice(4))
        //         if (r + g + b > 510)
        //             return '<style>.van-tabbar-item__text{color:#333}</style>'
        //     }
        //     return ''
        // },
    },

}
